// The nix_brand_ids for restaurants in Victoria
const brandIds = {
  Starbucks: "513fbc1283aa2dc80c00001f",
  Subway: "513fbc1283aa2dc80c000005",
  Freshii: "513fbc1283aa2dc80c0000a6",
  Fatburger: "513fbc1283aa2dc80c00014e",
  "Tim Horton's": "513fbc1283aa2dc80c000094",
  "Domino's": "513fbc1283aa2dc80c000003",
  "Mucho Burrito": "513fbc1283aa2dc80c000057",
  "The Keg": "513fbc1283aa2dc80c00017c",
  Earls: "513fbc1283aa2dc80c0001c6",
  "7-11": "513fbc1283aa2dc80c000184",
  "Panago Pizza": "513fbc1283aa2dc80c000278",
  "Lee's Famous Recipe Chicken": "513fbc1283aa2dc80c00082a",
  "White Spot Restaurants": "513fbc1283aa2dc80c000b8e",
  "De Dutch Pannekoek House": "513fbc1283aa2dc80c000b8a",
  "Orange Julius": "521b95434a56d006cae297be",
  "Thai Express": "521b95444a56d006cae298dc",
  "Burger King": "513fbc1283aa2dc80c00000a",
  "Manchu Wok": "513fbc1283aa2dc80c00000d",
  "Papa John’s": "513fbc1283aa2dc80c00000e",
  "Pizza Hut": "513fbc1283aa2dc80c000009",
  "Dairy Queen": "513fbc1283aa2dc80c000027",
  KFC: "513fbc1283aa2dc80c00001e",
  Popeyes: "513fbc1283aa2dc80c000029",
  "Little Caesars Pizza": "513fbc1283aa2dc80c000030",
  Cinnabon: "513fbc1283aa2dc80c000045",
  "McDonald's Canada": "61e5ddbdac32a8e539450cc3",
  "The Old Spaghetti Factory": "513fbc1283aa2dc80c00014b",
  "Red Robin": "521b95434a56d006cae29678",
  "Boston Pizza": "521b95434a56d006cae29705",
  "New York Fries": "521b95444a56d006cae29a0e",
  "Swiss Chalet": "53433c5bd84520603669e701",
  "Edo Japan": "581a131d4b69b9724a5cb851",
  "Costco Food Court": "57be0c972eb9319429e7689f",
  Cinnzeo: "586ffafcf86a70457373aa16",
  "A&W (Canada)": "5e6a5d8c93bdd7923d93ca1c",
  "Browns Socialhouse": "611ac4d3f1b6f5151902deec",
  "Bento Sushi": "611ade160bc769f53a576c60",
  Cora: "611d2daffdd8cfa35025393a",
};

export default brandIds;
